// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa-check-circle[data-v-71e60cca]{color:#04d504}", ""]);
// Exports
module.exports = exports;
